import React, { useState, useEffect } from "react";
import RegistrationForm from "../components/RegistrationForm";
import "../App.css";
import { Link } from "react-router-dom";

const RegistrationPage = () => {
  const [isDemoRequest, setIsDemoRequest] = useState(false);
  const [demoProduct, setDemoProduct] = useState("");

  // Check if this is a demo request
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isDemo = urlParams.get('demo');
    
    if (isDemo === 'true') {
      setIsDemoRequest(true);
      
      // Get demo product info from localStorage
      const demoData = localStorage.getItem('demoRequest');
      if (demoData) {
        try {
          const parsedData = JSON.parse(demoData);
          setDemoProduct(parsedData.product);
        } catch (error) {
          console.error('Error parsing demo data:', error);
        }
      }
    }
  }, []);

  return (
    <div className="registration-page-bg">
      <div className="registration-header">
        <h1 className="registration-header-title">
          {isDemoRequest ? `Request Demo - ${demoProduct}` : "Registration at Zip Account"}
        </h1>
      </div>
      <nav className="registration-breadcrumbs" style={{ justifyContent: 'center' }}>
        <Link to="/">Home</Link> 
        <span className="breadcrumb-separator">&gt;</span> 
        {isDemoRequest ? (
          <>
            <Link to="/demo/hr-management">Demo</Link>
            <span className="breadcrumb-separator">&gt;</span>
            <span>Request Demo</span>
          </>
        ) : (
          <span>Registration</span>
        )}
      </nav>
      <div className="registration-main">
        <div className="registration-image-container">
          <img
            src="/img/registration/registration_side.jpg"
            alt="Registration Visual"
            className="registration-image"
          />
        </div>
        <div className="registration-form-container">
          <RegistrationForm />
        </div>
      </div>
    </div>
  );
};

export default RegistrationPage; 